// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var ImportEnrichmentRule$ReactHooksTemplate = require("./importEnrichmentRule.res.js");
var ImportEnrichmentFieldOptions$ReactHooksTemplate = require("./ImportEnrichmentFieldOptions.res.js");
var ImportEnrichmentSimulationFixture$ReactHooksTemplate = require("./ImportEnrichmentSimulationFixture.res.js");

function formStepFromSectionId(sectionId) {
  switch (sectionId) {
    case "ier-section-test" :
        return "Test";
    case "ier-section-then" :
        return "Then";
    case "ier-section-when" :
        return "When";
    default:
      return "Basics";
  }
}

function sectionIdFromFormStep(step) {
  switch (step) {
    case "Basics" :
        return "ier-section-basics";
    case "When" :
        return "ier-section-when";
    case "Then" :
        return "ier-section-then";
    case "Test" :
        return "ier-section-test";
    
  }
}

function generateNodeId(prefix) {
  var rand = String(Math.random() * 1000000.0 | 0);
  return prefix + "_" + rand;
}

function emptyCondition(param) {
  return {
          id: generateNodeId("c"),
          path: "",
          op: "contains",
          value: "",
          pattern: "",
          format: "email",
          caseSensitive: false,
          regexMode: "Simple",
          builderMatchType: "contains",
          builderText: ""
        };
}

function emptyAction(param) {
  return {
          id: generateNodeId("a"),
          targetKind: "column",
          targetField: "channel",
          valueType: "Literal",
          valueLiteral: "",
          copyPath: "more_details.some_key",
          lookupPath: "more_details.some_key",
          lookupMapText: "",
          lookupDefault: "",
          regexPath: "context.feed_file.name",
          regexPattern: "",
          regexGroup: "1",
          regexCaseSensitive: false,
          regexMode: "Simple",
          regexBuilderMatchType: "contains",
          regexBuilderText: "",
          fromPath: "more_details.date_of_registration",
          toPath: "more_details.date_of_settlement",
          templateText: "",
          onlyIfBlank: false
        };
}

function pipelinesFromAppliesTo(appliesTo) {
  switch (appliesTo) {
    case "FeedImport" :
        return [
                true,
                false
              ];
    case "SurveyTrigger" :
        return [
                false,
                true
              ];
    case "Both" :
        return [
                true,
                true
              ];
    
  }
}

function applyScopeSelection(feedImportChecked, surveyTriggerChecked) {
  if (feedImportChecked) {
    if (surveyTriggerChecked) {
      return "Both";
    } else {
      return "FeedImport";
    }
  } else if (surveyTriggerChecked) {
    return "SurveyTrigger";
  } else {
    return "FeedImport";
  }
}

function makeSnapshot(name, priority, pipelineFeed, pipelineTrigger, conditionMode, conditions, actions) {
  return {
          snapName: name,
          snapPriority: priority,
          snapPipelineFeed: pipelineFeed,
          snapPipelineTrigger: pipelineTrigger,
          snapConditionMode: conditionMode,
          snapConditions: conditions,
          snapActions: actions
        };
}

var initialSnapshot = makeSnapshot("", 100, true, true, "All", /* [] */0, {
      hd: emptyAction(),
      tl: /* [] */0
    });

var initialState_selected = ImportEnrichmentRule$ReactHooksTemplate.empty();

var initialState_actions = {
  hd: emptyAction(),
  tl: /* [] */0
};

var initialState_simulationInputs = {};

var initialState_fieldOptions = ImportEnrichmentFieldOptions$ReactHooksTemplate.empty();

var initialState = {
  loading: true,
  saving: false,
  rules: /* [] */0,
  selected: initialState_selected,
  formOpen: false,
  conditionMode: "All",
  conditions: /* [] */0,
  actions: initialState_actions,
  pipelineFeed: true,
  pipelineTrigger: true,
  simulationInputs: initialState_simulationInputs,
  simulating: false,
  simulationResult: undefined,
  simulationSelection: "NoSelection",
  simulationHistory: /* [] */0,
  simulationView: "TraceView",
  searchTerm: "",
  statusFilter: "AllStatuses",
  scopeFilter: "AllPipelines",
  notification: undefined,
  fieldOptions: initialState_fieldOptions,
  formSnapshot: initialSnapshot
};

function reducer(state, action) {
  switch (action.TAG) {
    case "SetLoading" :
        var newrecord = Caml_obj.obj_dup(state);
        newrecord.loading = action._0;
        return newrecord;
    case "SetSaving" :
        var newrecord$1 = Caml_obj.obj_dup(state);
        newrecord$1.saving = action._0;
        return newrecord$1;
    case "SetRules" :
        var newrecord$2 = Caml_obj.obj_dup(state);
        newrecord$2.rules = action._0;
        return newrecord$2;
    case "SetSelected" :
        var newrecord$3 = Caml_obj.obj_dup(state);
        newrecord$3.selected = action._0;
        return newrecord$3;
    case "SetFormOpen" :
        var newrecord$4 = Caml_obj.obj_dup(state);
        newrecord$4.formOpen = action._0;
        return newrecord$4;
    case "SetConditionMode" :
        var newrecord$5 = Caml_obj.obj_dup(state);
        newrecord$5.conditionMode = action._0;
        return newrecord$5;
    case "SetConditions" :
        var newrecord$6 = Caml_obj.obj_dup(state);
        newrecord$6.conditions = action._0;
        return newrecord$6;
    case "SetActions" :
        var newrecord$7 = Caml_obj.obj_dup(state);
        newrecord$7.actions = action._0;
        return newrecord$7;
    case "SetSimulationInput" :
        var next = ImportEnrichmentSimulationFixture$ReactHooksTemplate.cloneInputs(state.simulationInputs);
        next[action._0] = action._1;
        var newrecord$8 = Caml_obj.obj_dup(state);
        newrecord$8.simulationInputs = next;
        return newrecord$8;
    case "SetSimulationInputs" :
        var newrecord$9 = Caml_obj.obj_dup(state);
        newrecord$9.simulationInputs = action._0;
        return newrecord$9;
    case "SetSimulating" :
        var newrecord$10 = Caml_obj.obj_dup(state);
        newrecord$10.simulating = action._0;
        return newrecord$10;
    case "SetSimulationResult" :
        var newrecord$11 = Caml_obj.obj_dup(state);
        newrecord$11.simulationResult = action._0;
        return newrecord$11;
    case "SetSimulationSelection" :
        var newrecord$12 = Caml_obj.obj_dup(state);
        newrecord$12.simulationSelection = action._0;
        return newrecord$12;
    case "PushSimulationHistory" :
        var history_0 = action._0;
        var history_1 = state.simulationHistory;
        var history = {
          hd: history_0,
          tl: history_1
        };
        var limited = Belt_List.fromArray(Belt_Array.slice(Belt_List.toArray(history), 0, 20));
        var newrecord$13 = Caml_obj.obj_dup(state);
        newrecord$13.simulationHistory = limited;
        return newrecord$13;
    case "SetSimulationHistory" :
        var newrecord$14 = Caml_obj.obj_dup(state);
        newrecord$14.simulationHistory = action._0;
        return newrecord$14;
    case "SetSimulationView" :
        var newrecord$15 = Caml_obj.obj_dup(state);
        newrecord$15.simulationView = action._0;
        return newrecord$15;
    case "SetSearchTerm" :
        var newrecord$16 = Caml_obj.obj_dup(state);
        newrecord$16.searchTerm = action._0;
        return newrecord$16;
    case "SetStatusFilter" :
        var newrecord$17 = Caml_obj.obj_dup(state);
        newrecord$17.statusFilter = action._0;
        return newrecord$17;
    case "SetScopeFilter" :
        var newrecord$18 = Caml_obj.obj_dup(state);
        newrecord$18.scopeFilter = action._0;
        return newrecord$18;
    case "SetNotification" :
        var newrecord$19 = Caml_obj.obj_dup(state);
        newrecord$19.notification = action._0;
        return newrecord$19;
    case "SetFieldOptions" :
        var newrecord$20 = Caml_obj.obj_dup(state);
        newrecord$20.fieldOptions = action._0;
        return newrecord$20;
    case "SetPipelineFeed" :
        var newrecord$21 = Caml_obj.obj_dup(state);
        newrecord$21.pipelineFeed = action._0;
        return newrecord$21;
    case "SetPipelineTrigger" :
        var newrecord$22 = Caml_obj.obj_dup(state);
        newrecord$22.pipelineTrigger = action._0;
        return newrecord$22;
    case "SetFormSnapshot" :
        var newrecord$23 = Caml_obj.obj_dup(state);
        newrecord$23.formSnapshot = action._0;
        return newrecord$23;
    
  }
}

function valueTypeToString(valueType) {
  switch (valueType) {
    case "Literal" :
        return "literal";
    case "CopyPath" :
        return "copy_path";
    case "LookupTable" :
        return "lookup_table";
    case "RegexCapture" :
        return "regex_capture";
    case "DateDiffDays" :
        return "date_diff_days";
    case "Template" :
        return "template";
    
  }
}

function valueTypeFromString(value) {
  switch (value) {
    case "copy_path" :
        return "CopyPath";
    case "date_diff_days" :
        return "DateDiffDays";
    case "lookup_table" :
        return "LookupTable";
    case "regex_capture" :
        return "RegexCapture";
    case "template" :
        return "Template";
    default:
      return "Literal";
  }
}

function valueTypeLabel(valueType) {
  switch (valueType) {
    case "Literal" :
        return "Fixed value";
    case "CopyPath" :
        return "Copy from another field";
    case "LookupTable" :
        return "Lookup value";
    case "RegexCapture" :
        return "Extract using pattern";
    case "DateDiffDays" :
        return "Calculate days between dates";
    case "Template" :
        return "Build text using fields";
    
  }
}

function isTransformValueType(valueType) {
  switch (valueType) {
    case "Literal" :
    case "CopyPath" :
        return false;
    default:
      return true;
  }
}

function primaryMethodForValueType(valueType) {
  switch (valueType) {
    case "Literal" :
        return "EnterValue";
    case "CopyPath" :
        return "CopyField";
    default:
      return "Transform";
  }
}

function valueTypeDescription(valueType) {
  switch (valueType) {
    case "Literal" :
        return "Type a specific text or number to store in this field.";
    case "CopyPath" :
        return "Use the value from another field on the same record.";
    case "LookupTable" :
        return "Translate a source value into a different target value, such as codes to labels.";
    case "RegexCapture" :
        return "Pull out part of a longer text value using a pattern.";
    case "DateDiffDays" :
        return "Store the number of days between two date fields.";
    case "Template" :
        return "Combine multiple fields and text into one value.";
    
  }
}

function pathDisplayLabel(fieldOptions, path) {
  var field = ImportEnrichmentFieldOptions$ReactHooksTemplate.findByPath(fieldOptions, path);
  if (field !== undefined) {
    return field.label;
  } else if (path.trim() === "") {
    return "…";
  } else {
    return path;
  }
}

function targetDisplayLabel(fieldOptions, targetKind, targetField) {
  var field = ImportEnrichmentFieldOptions$ReactHooksTemplate.findByTarget(fieldOptions, targetKind, targetField);
  if (field !== undefined) {
    return field.label;
  } else if (targetField.trim() === "") {
    return "…";
  } else {
    return targetField;
  }
}

function buildActionSummary(fieldOptions, row) {
  var target = targetDisplayLabel(fieldOptions, row.targetKind, row.targetField);
  var blankSuffix = row.onlyIfBlank ? " (only if empty)" : "";
  var match = row.valueType;
  switch (match) {
    case "Literal" :
        var value = row.valueLiteral.trim() === "" ? "…" : "\"" + row.valueLiteral + "\"";
        return "Set \"" + target + "\" to " + value + blankSuffix;
    case "CopyPath" :
        var source = pathDisplayLabel(fieldOptions, row.copyPath);
        return "Copy \"" + source + "\" into \"" + target + "\"" + blankSuffix;
    case "LookupTable" :
        var source$1 = pathDisplayLabel(fieldOptions, row.lookupPath);
        return "Set \"" + target + "\" using lookup from \"" + source$1 + "\"" + blankSuffix;
    case "RegexCapture" :
        var source$2 = pathDisplayLabel(fieldOptions, row.regexPath);
        return "Extract from \"" + source$2 + "\" into \"" + target + "\"" + blankSuffix;
    case "DateDiffDays" :
        var fromLabel = pathDisplayLabel(fieldOptions, row.fromPath);
        var toLabel = pathDisplayLabel(fieldOptions, row.toPath);
        return "Set \"" + target + "\" to days between \"" + fromLabel + "\" and \"" + toLabel + "\"" + blankSuffix;
    case "Template" :
        var preview = row.templateText.trim() === "" ? "…" : "\"" + row.templateText + "\"";
        return "Build text for \"" + target + "\": " + preview + blankSuffix;
    
  }
}

function opLabel(op) {
  switch (op) {
    case "blank" :
        return "is empty";
    case "contains" :
        return "contains";
    case "ends_with" :
        return "ends with";
    case "eq" :
        return "is equal to";
    case "gt" :
        return "is greater than";
    case "gte" :
        return "is greater than or equal to";
    case "in_list" :
        return "is one of";
    case "lt" :
        return "is less than";
    case "lte" :
        return "is less than or equal to";
    case "matches_format" :
        return "matches format";
    case "neq" :
        return "is not equal to";
    case "not_contains" :
        return "does not contain";
    case "present" :
        return "is not empty";
    case "regex_match" :
        return "matches regex (legacy)";
    case "starts_with" :
        return "starts with";
    default:
      return op;
  }
}

var transformPrimaryDescription = "Lookup values or calculate days between two date fields.";

exports.formStepFromSectionId = formStepFromSectionId;
exports.sectionIdFromFormStep = sectionIdFromFormStep;
exports.generateNodeId = generateNodeId;
exports.emptyCondition = emptyCondition;
exports.emptyAction = emptyAction;
exports.pipelinesFromAppliesTo = pipelinesFromAppliesTo;
exports.applyScopeSelection = applyScopeSelection;
exports.makeSnapshot = makeSnapshot;
exports.initialSnapshot = initialSnapshot;
exports.initialState = initialState;
exports.reducer = reducer;
exports.valueTypeToString = valueTypeToString;
exports.valueTypeFromString = valueTypeFromString;
exports.valueTypeLabel = valueTypeLabel;
exports.isTransformValueType = isTransformValueType;
exports.primaryMethodForValueType = primaryMethodForValueType;
exports.valueTypeDescription = valueTypeDescription;
exports.transformPrimaryDescription = transformPrimaryDescription;
exports.pathDisplayLabel = pathDisplayLabel;
exports.targetDisplayLabel = targetDisplayLabel;
exports.buildActionSummary = buildActionSummary;
exports.opLabel = opLabel;
/* initialSnapshot Not a pure module */
